const TickIcon = ({ color = "var(--green)", size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 21.6004C14.5461 21.6004 16.9879 20.589 18.7882 18.7886C20.5886 16.9883 21.6 14.5465 21.6 12.0004C21.6 9.45431 20.5886 7.01251 18.7882 5.21217C16.9879 3.41182 14.5461 2.40039 12 2.40039C9.45395 2.40039 7.01215 3.41182 5.2118 5.21217C3.41145 7.01251 2.40002 9.45431 2.40002 12.0004C2.40002 14.5465 3.41145 16.9883 5.2118 18.7886C7.01215 20.589 9.45395 21.6004 12 21.6004ZM16.4484 10.4488C16.667 10.2225 16.788 9.91935 16.7852 9.60471C16.7825 9.29007 16.6563 8.9891 16.4338 8.76661C16.2113 8.54412 15.9103 8.41792 15.5957 8.41518C15.2811 8.41245 14.9779 8.5334 14.7516 8.75199L10.8 12.7036L9.24842 11.152C9.0221 10.9334 8.71898 10.8124 8.40434 10.8152C8.08971 10.8179 7.78873 10.9441 7.56624 11.1666C7.34375 11.3891 7.21755 11.6901 7.21482 12.0047C7.21208 12.3193 7.33303 12.6225 7.55162 12.8488L9.95162 15.2488C10.1767 15.4738 10.4818 15.6001 10.8 15.6001C11.1182 15.6001 11.4234 15.4738 11.6484 15.2488L16.4484 10.4488Z"
        fill={color}
      />
    </svg>
  );
};

export default TickIcon;
